import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Enum } from '../interfaces/enum.interface';

@Injectable({ providedIn: 'root' })
export class LayoutConfigService {
  private document = inject(DOCUMENT);

  private logoSubject: BehaviorSubject<string> = new BehaviorSubject<string>(
    '',
  );

  private default = {
    logo: {
      desktop: '',
      sticky: '',
    },
    loader: {
      enabled: true,
      type: 'spinner',
      logo: '',
      message: 'Por favor, aguarde...',
    },
  };

  public setTheme(theme: Enum) {
    switch (theme.value) {
      case 16: {
        this.setLogo('./assets/media/logos/logo-byd.svg');
        this.setFavIcon('./assets/media/logos/favicon-byd.ico');
        this.setLinkTheme('byd.css');
        break;
      }
      case 2: {
        this.setLogo('./assets/media/logos/logo-honda.svg');
        this.setFavIcon('./assets/media/logos/favicon-honda.ico');
        this.setLinkTheme('sidapecas.css');
        break;
      }
      case 3: {
        this.setLogo('./assets/media/logos/logo-jacto.svg');
        this.setFavIcon('./assets/media/logos/favicon-jacto.png');
        this.setLinkTheme('jacto.css');
        break;
      }
      case 4: {
        this.setLogo('./assets/media/logos/logo-renault.svg');
        this.setFavIcon('./assets/media/logos/favicon-renault-new.ico');
        this.setLinkTheme('renault.css');
        break;
      }
      case 5: {
        this.setLogo('./assets/media/logos/logo_nissan.png');
        this.setFavIcon('./assets/media/logos/favicon_nissan.ico');
        this.setLinkTheme('sidapecas.css');
        break;
      }
      case 6: {
        this.setLogo('./assets/media/logos/logo-fiat.svg');
        this.setFavIcon('./assets/media/logos/favicon-fiat.png');
        this.setLinkTheme('fiat.css');
        break;
      }
      case 7: {
        this.setLogo('./assets/media/logos/logo-hyundai.svg');
        this.setFavIcon('./assets/media/logos/favicon_hyundai.png');
        this.setLinkTheme('hyundai.css');
        break;
      }
      case 8: {
        this.setLogo('./assets/media/logos/logo-vw.svg');
        this.setFavIcon('./assets/media/logos/favicon-vw.png');
        this.setLinkTheme('volkswagen.css');
        break;
      }
      case 9: {
        this.setLogo('./assets/media/logos/logo-kia.svg');
        this.setFavIcon('./assets/media/logos/favicon-kia.ico');
        this.setLinkTheme('kia.css');
        break;
      }
      case 11: {
        this.setLogo('./assets/media/logos/logo-assochery.png');
        this.setFavIcon('./assets/media/logos/favicon-chery.ico');
        this.setLinkTheme('chery.css');
        break;
      }
      case 15: {
        this.setLogo('./assets/media/logos/logo-psa.svg');
        this.setFavIcon('./assets/media/logos/favicon-psa.png');
        this.setLinkTheme('psa.css');
        break;
      }
      case 10: {
        this.setLogo('./assets/media/logos/logo-gm.svg');
        this.setFavIcon('./assets/media/logos/favicon-gm.ico');
        this.setLinkTheme('gm.css');
        break;
      }
      case 12: {
        this.setLogo('./assets/media/logos/logo-abrajeep.svg');
        this.setFavIcon('./assets/media/logos/favicon-abrajeep.png');
        this.setLinkTheme('abrajeep.css');
        break;
      }
      case 22: {
        this.setLogo('./assets/media/logos/logo-abrahy.svg');
        this.setFavIcon('./assets/media/logos/favicon-abrahy.ico');
        this.setLinkTheme('abrahy.css');
        break;
      }
      case 13: {
        this.setLogo('./assets/media/logos/logo-toyota.svg');
        this.setFavIcon('./assets/media/logos/favicon-toyota.svg');
        this.setLinkTheme('toyota.css');
        break;
      }
      case 14: {
        this.setLogo('./assets/media/logos/logo-carrier.svg');
        this.setFavIcon('./assets/media/logos/favicon-carrier.png');
        this.setLinkTheme('carrier.css');
        break;
      }
      case 17: {
        this.setLogo('./assets/media/logos/logo-ford.svg');
        this.setFavIcon('./assets/media/logos/favicon-ford.ico');
        this.setLinkTheme('ford.css');
        break;
      }
      case 18: {
        this.setLogo('./assets/media/logos/logo-unimassey.svg');
        this.setFavIcon('./assets/media/logos/favicon-unimassey.png');
        this.setLinkTheme('unimassey.css');
        break;
      }
      case 19: {
        this.setLogo('./assets/media/logos/logo-mitsubishi.svg');
        this.setFavIcon('./assets/media/logos/favicon-mitsubishi.png');
        this.setLinkTheme('mitsubishi.css');
        break;
      }
      case 20: {
        this.setLogo('./assets/media/logos/logo-geely.svg');
        this.setFavIcon('./assets/media/logos/favicon-geely.ico');
        this.setLinkTheme('geely.css');
        break;
      }
      case 21: {
        this.setLogo('./assets/media/logos/logo-gwm.svg');
        this.setFavIcon('./assets/media/logos/favicon-gwm.ico');
        this.setLinkTheme('gwm.css');
        break;
      }
      case 23: {
        this.setLogo('./assets/media/logos/logo-omodajaecoo.svg');
        this.setFavIcon('./assets/media/logos/favicon-omodajaecoo.png');
        this.setLinkTheme('omodajaecoo.css');
        break;
      }
      case 24: {
        this.setLogo('./assets/media/logos/logo-mobis.svg');
        this.setFavIcon('./assets/media/logos/favicon-mobis.png');
        this.setLinkTheme('mobis.css');
        break;
      }
      case 1:
      default: {
        this.setLogo('./assets/media/logos/Logo.png');
        this.setFavIcon('./assets/media/logos/favicon.ico');
        this.setLinkTheme('teu-estoque.css');
      }
    }
  }

  private setLinkTheme(link: string) {
    const head = this.document.getElementsByTagName('head')[0];
    const style = this.document.createElement('link');
    style.id = 'client-theme';
    style.rel = 'stylesheet';
    style.href = link;

    head.appendChild(style);
  }

  private setFavIcon(link: string) {
    const favicon = this.document.getElementById('fav-icon') as HTMLLinkElement;
    if (favicon) {
      favicon.href = link;
    }
  }

  private setLogo(logo: string) {
    this.logoSubject.next(logo);
  }

  public getLogo(): Observable<string> {
    return this.logoSubject.asObservable();
  }
}
